import { useEffect, useRef, useState } from "react";
import { Board } from "./types";
import { START_OFFSET } from "./App";

export const useRefBoard = (board: Board) => {
  const ref = useRef<Board>(board);
  const update = (board: Board) => {
    ref.current = board;
  };
  return [ref, update] as [React.MutableRefObject<Board>, (board: Board) => {}];
};

export const useCanvasSize = () => {
  const [canvasSize, setCanvasSize] = useState<number | null>(null);
  const [boardSize, setBoardSize] = useState(0);
  const [cellSize, setCellSize] = useState(0);

  useEffect(() => {
    const canvasWrapper = document.querySelector("#canvas-wrapper");
    if (canvasWrapper) {
      const { clientHeight, clientWidth } = canvasWrapper;

      const canvasSize = Math.min(clientHeight, clientWidth);
      const boardSize = canvasSize - START_OFFSET * 2;
      const cellSize = boardSize / 9

      setCanvasSize(canvasSize);
      setBoardSize(boardSize);
      setCellSize(cellSize);
    }
  }, []);

  return [canvasSize, boardSize, cellSize] as [number | null, number, number];
};
